import { useQuery } from '@tanstack/react-query';
import LessonService from '../Services/lessons/LessonService';

export const GET_LESSONS_QUERY_KEY = 'getLessons';
export const SHOW_LESSON_DETAILS_QUERY_KEY = 'showLessonDetails';

export const useGetLessons = () => {
  return useQuery({
    queryKey: [GET_LESSONS_QUERY_KEY],
    queryFn: LessonService.listAllLessons,
  });
};

export const useShowLessonDetails = (id) => {
  return useQuery({
    queryKey: [SHOW_LESSON_DETAILS_QUERY_KEY, id],
    queryFn: () => LessonService.showLessonDetails(id),
  });
};